import {
  OUTCOMES_GET_BY_CLIENT_AND_PROGRAM,
  OUTCOMES_GET_BY_CLIENT_AND_PROGRAM_SUCCESS,
  OUTCOMES_SAVE,
  OUTCOMES_ERROR,
} from './types';

const initialState = {
  items: [],
  item: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case OUTCOMES_SAVE:
    case OUTCOMES_GET_BY_CLIENT_AND_PROGRAM:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case OUTCOMES_GET_BY_CLIENT_AND_PROGRAM_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };
    case OUTCOMES_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
